import { gql } from '@apollo/client'

export const AI_CONVERSATIONS_QUERY = gql`
  query AI_CONVERSATIONS_QUERY($pagination: PaginationInput!, $filter: AiConversationFilterInput) {
    aiConversations(pagination: $pagination, filter: $filter) {
      data {
        id
        title
        createdAt
        updatedAt
      }
    }
  }
`

export const AI_MESSAGES_QUERY = gql`
  query AI_MESSAGES_QUERY($conversationId: ID!, $pagination: PaginationInput!) {
    aiMessages(conversationId: $conversationId, pagination: $pagination) {
      data {
        id
        role
        content
        createdAt
        records {
          riskId
          templateId
          title
        }
        riskSuggestions {
          title
          fields {
            fieldId
            value
          }
        }
      }
    }
  }
`

export const AI_USAGE_QUERY = gql`
  query AI_USAGE_QUERY($filter: AiUsageFilterInput) {
    aiUsageStats(filter: $filter) {
      totalCost
      totalConversations
    }
  }
`
